import { PaletteMode } from '@mui/material';
import { SVG_NEUTRAL_KEYS } from '../../iconColors';
import { buildComponentTokens } from '../components';
import { LookTokens, mergeTokens, SvgPaints } from '../index';
import { colors } from '../primitives';
import { buildColorTokens, buildScaleTokens } from '../semantic';
import { exoColors } from './exosphere';
import { getBoomiComponentOverrides } from './components';
import { getBoomiPrimitives } from './primitives';
import {
  getBoomiColorOverrides,
  getBoomiElevations,
  getBoomiScaleOverrides,
} from './semantic';

const getSvgPaints = (mode: PaletteMode, legacy: typeof colors): SvgPaints => {
  const exo = exoColors[mode];
  return {
    paints: {
      ...Object.fromEntries(
        SVG_NEUTRAL_KEYS.map((key) => [
          colors[key],
          key === 'black' ? exo.icon : legacy[key],
        ]),
      ),
      // Gray of disabled icon assets (the disabled sync icon).
      '#D9D9E8': exo['font-disabled'],
      // The critical-asset marker is AI lilac; pink and lilac stay for AI.
      '#E4ABFC': exo['data-solid-purple'],
    },
    ...(legacy.white !== colors.white && { white: legacy.white }),
    black: legacy.black,
    ...(mode === 'dark' && { brandInk: exo.font }),
  };
};

const createBoomiLook = (mode: PaletteMode): LookTokens => {
  const primitives = getBoomiPrimitives(mode);
  const colorTokens = mergeTokens(
    buildColorTokens(primitives),
    getBoomiColorOverrides(mode),
  );
  const scaleTokens = mergeTokens(
    buildScaleTokens(colorTokens, primitives),
    getBoomiScaleOverrides(mode),
  );
  const componentTokens = mergeTokens(
    buildComponentTokens(colorTokens, scaleTokens),
    getBoomiComponentOverrides(mode),
  );

  return {
    mode,
    colors: colorTokens,
    tokens: {
      ...scaleTokens,
      components: componentTokens,
      svgPaints: getSvgPaints(mode, primitives.colors),
    },
    shadows: getBoomiElevations(mode),
  };
};

export const boomiLightLook = createBoomiLook('light');

export const boomiDarkLook = createBoomiLook('dark');
